<template>
  <div
    v-if="!removeFromDOM"
    class="jfpc"
    :class="themeClass"
    :publisher-component-id="id"
    :publisher-component-placement="componentPlacement"
    :instance-id="instanceId"
  >

    <div v-if="loaded" class="standard-ads flex justify-center inline-grid gap-4 grid-cols-1 w-full">

      <div v-if="progressiveFeaturedAd !== null">

        <p class="font-medium text-center mb-4" style="font-size: 20px">
          We've analyzed rates from top insurers. You've been matched with <b class="font-black">Progressive</b>
        </p>

        <tw-card
          class="quinstreet-ads__ad-card h-auto relative"
          @click.native="triggerAdClick(progressiveFeaturedAd)"
          style="height: fit-content; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); cursor: pointer; position: relative;min-height: 300px; border: 1px solid #C9C9C9"
          flat
          no-padding
        >
          <div class="ribbon">Your Top Pick</div>
          <div class="border-b p-4" style="min-height: 56px; border-color: #C9C9C9">
            <img src="https://d2z3ffoe99vnx9.cloudfront.net/vertical_images/progressive-logo.png" style="width: 170px; max-width: 50%" />
          </div>
          <div class="p-4">
            <div class="rounded p-4 text-center" style="background: #E8F6FE">
              <p class="font-bold" style="font-size: 18px">
                Progressive is offering special incentives and rates in {{ searchLocationState }}. You may be eligible for over $740 in policy savings
              </p>
              <img src="https://d2z3ffoe99vnx9.cloudfront.net/vertical_images/progressive-flo.png" style="width: 250px; margin: 0 auto" />
              <tw-button type="secondary" full-width no-caps class="font-bold mb-2" style="font-size: 20px; background: #F97317 !important;">
                <template v-slot:label>
                  Continue Quote
                  <icon-arrow-right class="ml-1" size="18" />
                </template>
              </tw-button>
            </div>
          </div>
        </tw-card>

        <div v-if="!showAds && ads.length > 0" class="text-center mt-6 mb-2">
          <p class="font-medium" style="font-size: 16px; color: #939393; cursor: pointer" @click="() => { showAds = true; }">
            See Other Quotes
          </p>
        </div>
      </div>


      <template v-if="showAds">
        <tw-card
          v-for="(ad, i) in ads"
          :key="i + '_quinstreet_ad'"
          :ref="'quinstreetAdsAd_' + i"
          class="quinstreet-ads__ad-card h-auto relative"
          @click.native="triggerAdClick(ad)"
          style="height: fit-content; box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1); cursor: pointer"
          :style="[
            { 'background': (ad.datapass_available == 1 ? '#FFFFF5 !important' : '#F9F9F9 !important') }
          ]"
        >
          <div>
            <div v-if="ad.datapass_available == 1" class="ad-card__featured-container">
              <svg width="30px" height="29px" viewBox="0 0 30 29" style="position: absolute;left: 5px;top: 3px;width: 20px;height: 20px;">
                <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g class="icon__star-fill" fill="#FFF" fill-rule="nonzero">
                    <path d="M16.428125,0.92875 L19.8075,7.77625 C20.0425,8.2525 20.496875,8.5825 21.0225,8.65875 L28.579375,9.756875 C29.903125,9.949375 30.43125,11.575625 29.47375,12.50875 L24.005625,17.83875 C23.625625,18.209375 23.451875,18.74375 23.541875,19.266875 L24.8325,26.793125 C25.05875,28.11125 23.675,29.11625 22.49125,28.494375 L15.7325,24.94125 C15.2625,24.694375 14.700625,24.694375 14.230625,24.94125 L7.471875,28.494375 C6.288125,29.116875 4.904375,28.11125 5.130625,26.793125 L6.42125,19.266875 C6.51125,18.74375 6.3375,18.209375 5.9575,17.83875 L0.489375,12.50875 C-0.468125,11.575 0.06,9.94875 1.38375,9.756875 L8.940625,8.65875 C9.46625,8.5825 9.920625,8.2525 10.155625,7.77625 L13.535,0.92875 C14.12625,-0.270625 15.83625,-0.270625 16.428125,0.92875 Z" id="Shape"></path>
                  </g>
                </g>
              </svg>
            </div>

            <div class="flex flex-col justify-center items-center">
              <img :src="ad.raw_logo" class="border p-2 bg-white" style="width: 140px; max-width: 140px" />
              <p class="font-bold mt-3 text-center" style="font-size: 18px" v-html="ad.title" />
              <p class="text-xs mt-2" style="color: #2581FE !important;"> {{ ad.sitehost }}</p>

              <div class="my-2 w-full">
                <div :id="'ad_description_' + i" class="ad-card__description mb-3 w-full text-left" v-html="ad.description" />
                <div :id="'ad_description_toggle_icon_' + i" class="ad-card__description-toggle-icon w-full border-t mt-2 mb-6 relative" style="border-color: #D8D8D8 !important;" @click.prevent.stop="toggleAdDescription(i)">
                  <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="25px" height="25px" viewBox="0 0 25 25" style="enable-background:new 0 0 25 25;position: absolute; top: -12px; left:0; right: 0; margin-inline: auto; width: fit-content" xml:space="preserve">
                  <circle fill="#777777" cx="12.5" cy="12.5" r="12.5"></circle>
                    <path fill="#FFFFFF" d="M7.9,9.1l4.6,4.6l4.6-4.6l1.4,1.4l-6,6l-6-6L7.9,9.1z"></path>
                    <path fill="none" d="M0.5,0.5h24v24h-24V0.5z"></path>
                </svg>
                </div>
              </div>

              <tw-button label="View My Quote" type="secondary" full-width no-caps class="font-bold" style="font-size: 20px; background: #2581FE !important;" />
            </div>
          </div>
        </tw-card>
      </template>
    </div>
    <div v-else class="flex justify-center grid gap-4 grid-cols-1">
      <tw-card v-for="i in (numAds > 0 ? numAds : 4)" :key="i + '_ad'" :ref="'autoInsuranceAdsAdSkeleton_' + i">
        <div class="animate-pulse flex-col space-y-4">
          <div class="w-full">
            <div class="h-3 bg-gray-300 rounded w-full" />
          </div>
          <div class="flex flex-nowrap items-center space-x-4">
            <div class="w-5/12">
              <div class="h-16 bg-gray-300 rounded w-full" />
            </div>
            <div class="w-7/12">
              <div class="h-3 bg-gray-300 rounded w-full" />
              <div class="h-3 bg-gray-300 rounded w-11/12 mt-2" />
              <div class="h-3 bg-gray-300 rounded w-10/12 mt-2" />
            </div>
          </div>
        </div>
      </tw-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
import PublisherBase from "@/mixins/Publisher/PublisherBase";
import TwCard from "@/components/Tailwind/TwCard";
import axios from "axios";
import TwButton from "@/components/Tailwind/TwButton.vue";
import IconArrowRight from "@/components/Icon/IconArrowRight.vue";

export default {
  name: "ExternalAdUnitQuinstreet",
  components: { IconArrowRight, TwButton, TwCard},
  mixins: [
    PublisherBase
  ],
  props: {
    ...PublisherBase.props,
    containerId: {
      type: String,
      default: "quinstreet_container"
    },
    numAds: {
      type: [String,Number],
      default: 0
    },
    progressiveFeaturedAdDesign: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: 28,
      advertiserAccountId: 1050,
      loaded: false,
      showAds: true,
      ads: [],
      eventsSearchData: {},
      progressiveFeaturedAd: null,
      searchLocationState: "your area"
    };
  },
  computed: {},
  mounted() {},
  methods: {
    componentInit() {
      return new Promise((resolve) => {
        this.domElement.searchData = this.domElement.searchData ?? {
          contact: {
            zip: this.visitorLocation.postalCode
          }
        };

        if (typeof this.domElement.searchData.contact.zip !== "undefined") {
          this.getPostalCodeLocationData(this.domElement.searchData.contact.zip.toString())
            .then(data => {
              if(data.state.length > 0) {
                this.searchLocationState = this.getFullStateName(data.state);
              }
            });
        }

        // Configure standardized search data object that can be passed w/ events
        if (typeof this.domElement.searchData.contact !== "undefined") {
          this.eventsSearchData.postal_code = typeof this.domElement.searchData.contact.zip !== "undefined" ? this.domElement.searchData.contact.zip : null;
          this.eventsSearchData.own_home = typeof this.domElement.searchData.contact.homeowner !== "undefined" ? this.domElement.searchData.contact.homeowner : null;
          this.eventsSearchData.age = typeof this.domElement.searchData.contact.age !== "undefined" ? this.domElement.searchData.contact.age : null;
          this.eventsSearchData.first_name = typeof this.domElement.searchData.contact.first_name !== "undefined" && this.domElement.searchData.contact.first_name.length > 0 ? this.domElement.searchData.contact.first_name : null;
          this.eventsSearchData.last_name = typeof this.domElement.searchData.contact.last_name !== "undefined" && this.domElement.searchData.contact.last_name.length > 0 ? this.domElement.searchData.contact.last_name : null;
          this.eventsSearchData.email = typeof this.domElement.searchData.contact.email !== "undefined" && this.domElement.searchData.contact.email.length > 0 ? this.domElement.searchData.contact.email : null;
          this.eventsSearchData.phone = typeof this.domElement.searchData.contact.home_phone !== "undefined" ? this.domElement.searchData.contact.home_phone.replace(/\D/g, '') : null;
          this.eventsSearchData.pii = null
        }
        if (typeof this.domElement.searchData.current_insurance !== "undefined") {
          this.eventsSearchData.currently_insured = typeof this.domElement.searchData.current_insurance.currently_insured !== "undefined" ? this.domElement.searchData.current_insurance.currently_insured : null;
          this.eventsSearchData.current_insurer = typeof this.domElement.searchData.current_insurance.carrier !== "undefined" ? this.domElement.searchData.current_insurance.carrier : null;
        }
        if (typeof this.domElement.searchData.requested_coverage !== "undefined") {
          this.eventsSearchData.own_multiple_vehicles = typeof this.domElement.searchData.requested_coverage.vehicle_count !== "undefined" ? (this.domElement.searchData.requested_coverage.vehicle_count > 1 ? 1 : 0) : null;
          this.eventsSearchData.bundle_home_auto = typeof this.domElement.searchData.requested_coverage.bundle_insurance !== "undefined" ? this.domElement.searchData.requested_coverage.bundle_insurance : null;
        }
        this.eventsSearchData.num_drivers = typeof this.domElement.searchData.individuals !== "undefined" ? this.domElement.searchData.individuals.length : null;
        if ( this.eventsSearchData.first_name !== null && this.eventsSearchData.first_name.length > 0
            || this.eventsSearchData.last_name !== null && this.eventsSearchData.last_name.length > 0
            || this.eventsSearchData.email !== null
            || this.eventsSearchData.phone !== null) {
          this.eventsSearchData.pii = 1;
        }

        this.loadQuinstreetAds();

        resolve();
      });
    },
    loadQuinstreetAds() {
      this.loaded = false;

      this.domElement.searchData.tracking = this.domElement.searchData.tracking || {};
      this.domElement.searchData.tracking.ni_var1 = this.publisherEventData.publisher_channel_1;
      this.domElement.searchData.tracking.ni_var2 = this.publisherEventData.publisher_channel_3;

      if (this.urlParams.get("qspl") && this.urlParams.get("qspl").length > 0) {
        this.domElement.searchData.tracking.ni_ad_client = this.urlParams.get("qspl");
      }

      axios.post("https://api-v2.jumpfeed.com/network/publisher/quinstreet-auto-insurance-ads", this.domElement.searchData)
      .then(response => {
        let ads = response.data.data;

        if (ads.length === 0) {
          this.triggerNoContentLoaded({
            advertiser_account_id: this.advertiserAccountId,
            search_data: this.eventsSearchData
          });
        }
        else {
          if (this.progressiveFeaturedAdDesign) {
            ads.some((ad, i) => {
              if (ad.company == "Progressive") {
                this.progressiveFeaturedAd = ad;
                ads.splice(i, 1);
                this.showAds = false;
                this.$emit('using-progressive-featured-design', ad);
                return true;
              }
              return false;
            });
          }

          this.ads = this.numAds > 0 ? ads.slice(0, this.numAds) : ads;
          this.jfpTrack("ContentView", {
            advertiser_account_id: this.advertiserAccountId,
            search_data: this.eventsSearchData
          });
          this.ads.forEach(ad => {
            let img = document.createElement("img");
            img.src = ad.imp_pixel;
            img.height = 0;
            img.width = 0;
            document.body.appendChild(img);
          });
        }

        this.loaded = true;
        this.$emit('ads-loaded', ads);
      })
      .catch(error => {
        console.log(error);
        this.loaded = true;
        this.triggerNoContentLoaded({
          advertiser_account_id: this.advertiserAccountId,
          advertiser_channel_1: 0,
          search_data: this.eventsSearchData
        });
      });
    },
    toggleAdDescription(adIndex) {
      let adDescriptionContainer = document.getElementById("ad_description_" + adIndex);
      let adDescriptionToggleIcon = document.getElementById("ad_description_toggle_icon_" + adIndex);
      if (adDescriptionContainer && adDescriptionToggleIcon) {
        adDescriptionContainer.classList.toggle("--toggled");
        adDescriptionToggleIcon.classList.toggle("--toggled");
      }
    },
    triggerAdClick(ad) {
      this.jfpTrack("ContentClick", {
        advertiser_account_id: this.advertiserAccountId,
        advertiser_external_content_id: ad.impressionid,
        event_value: ad.cpc,
        advertiser_channel_1: ad.sitehost,
        search_data: this.eventsSearchData
      });

      let destinationUrl = "https://" + this.subdomain + "/out.php?d=" + encodeURIComponent(ad.clickurl);

      if(this.urlParams.get("pnt") == 1 || this.isFacebookUserAgent()) {
        window.location.href = destinationUrl;
      } else {
        window.open(destinationUrl, "_blank");
      }
    }
  }
}
</script>

<style src="@/styles/index.css" />

<style>
.ad-card__featured-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 50px;
  height: 50px;
}
.ad-card__featured-container::before {
  display: block;
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 50px 50px 0 0;
  border-color: #ffee36 transparent transparent transparent;
}
.ad-card__description {
  font-size: 12px;
  max-height: 0;
  overflow: hidden;
  will-change: max-height;
  transition: max-height 0.3s ease-in-out;
}
.ad-card__description.--toggled {
  max-height: 300px;
}
.ad-card__description-toggle-icon.--toggled {
  rotate: 180deg;
}
.ad-card__description ul {
  list-style: inside;
}
.ad-card__description ul li {
  padding-bottom: 2px;
}
.ribbon {
  font-size: 18px;
  font-weight: 600;
  color: #fff;
  --r: .5em; /* control the ribbon shape (the radius) */
  --c: #34AAF4;
  position: absolute;
  top: 8px;
  right: calc(-1*var(--r));
  line-height: 2.2;
  padding: 0 1.2em calc(2*var(--r));
  border-radius: 0 var(--r) var(--r) 0;
  background:
      radial-gradient(100% 50% at right,var(--c) 98%,#0000 101%)
      0 0/.5lh calc(100% - 2*var(--r)),
      radial-gradient(100% 50% at left,#0005 98%,#0000 101%)
      100% 100%/var(--r) calc(2*var(--r)),
      conic-gradient(from 180deg at calc(100% - var(--r)) calc(100% - 2*var(--r)),#0000 25%,var(--c) 0)
      100% 0/calc(101% - .5lh) 100%;
  background-repeat: no-repeat;
}
</style>